<template>
  <div class="card" v-if="statistics">
    <div class="card--content">
      <div class="card--number">
        <div class="card--number-value">
          {{businessKitPerLead}}
        </div>
        <div class="card--number-key">
          {{$t('statistics.businesskit_per_lead')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { round } from "./StatisticsHelpers";

export default {
  name: 'bk-per-lead',
  props: ['statistics'],
  methods: {
    
  },
  computed: {
    businessKitPerLead(){
      let leads = this.statistics.leads_count
      let businesskits = this.statistics.sent_business_kits_count
      if(leads == 0){
        return 0
      }
      let result = businesskits / leads
      result = round(result,2)
      return result
    }
  }
}
</script>


// WEBPACK FOOTER //
// ProjectStatisticsBkPerLead.vue?071fee02